import React, { useMemo } from "react";
import moment from "moment";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { PRINT_ORDER, USER_KEY } from "../../const";
import { convertOrderStatus, numberFormat } from "../../helper";

function BillForCheckOutA4V3(props) {
  const { t, i18n } = useTranslation();
  const userData = JSON.parse(localStorage.getItem(USER_KEY))?.data;
  const cartActive = useMemo(
    () => props?.cartDatas?.find((e) => e?.label === props?.activeCart),
    [props?.cartDatas, props?.activeCart]
  );
  const status = JSON.parse(localStorage.getItem(PRINT_ORDER))?.status || "";

  const themeByShop = JSON.parse(localStorage.getItem("CUSTOM_THEME_BY_SHOP"))?.datas;
  const themePrimary = themeByShop?.counterScreen || themeByShop?.customTheme || "var(--purple-color)";
  const themeGradient = themeByShop?.customTheme || "var(--linea-gradient)";

  const shop = props?.shopData?.shop || userData?.shop || {};
  const orderGroup = cartActive?.data?.orderGroup || {};
  const orders = cartActive?.data?.orders || [];
  const showFreeColumn = orders?.some((o) => Number(o?.amountFree || 0) > 0);

  const text = useMemo(
    () => ({
      tel: t("tel", { defaultValue: "ໂທ" }),
      invoiceTitle: t("invoice_titleV2", { defaultValue: "ໃບບິນຮັບເງິນ" }),
      customerInfoTitle: t("bill_customer_info_title", { defaultValue: "ຂໍ້ມູນລູກຄ້າ" }),
      billInfoTitle: t("bill_info_title", { defaultValue: "ຂໍ້ມູນໃບບິນ" }),
      customerName: t("customer_name", { defaultValue: "ຊື່ລູກຄ້າ" }),
      address: t("address", { defaultValue: "ທີ່ຢູ່" }),
      phoneNumber: t("phone_number", { defaultValue: "ເບີໂທ" }),
      createdBy: t("createdBy", { defaultValue: "ພະນັກງານຂາຍ" }),
      billNo: t("number_no", { defaultValue: "ເລກທີ່ບິນ" }),
      dayMonthYear: t("day_month_year", { defaultValue: "ວັນທີ" }),
      status: t("status", { defaultValue: "ສະຖານະ" }),
      currency: t("currency", { defaultValue: "ສະກຸນເງິນ" }),
      tbNo: t("tb_no", { defaultValue: "ລ/ດ" }),
      tbLot: t("tb_lot", { defaultValue: "ເລກລ໊ອຕ" }),
      productName: t("product_name_tb", { defaultValue: "ຊື່ສິນຄ້າ" }),
      tbSize: t("tb_size", { defaultValue: "Size" }),
      qty: t("qty_name_tb", { defaultValue: "ຈຳນວນ" }),
      tbFree: t("tb_free", { defaultValue: "ແຖມ" }),
      unit: t("unit_name_tb", { defaultValue: "ຫົວໜ່ວຍ" }),
      price: t("price_name_tb", { defaultValue: "ລາຄາ" }),
      tbAmount: t("tb_amount", { defaultValue: "ລວມ" }),
      noData: t("empty_name_list", { defaultValue: "ບໍ່ພົບເຫັນຂໍ້ມູນ!!!" }),
      note: t("note", { defaultValue: "ໝາຍເຫດ" }),
      noteDefault: t("bill_note_default", { defaultValue: "ສິນຄ້າບໍ່ສາມາດຄືນໄດ້" }),
      discount: t("discount_name", { defaultValue: "ສ່ວນຫຼຸດ" }),
      shippingCost: t("shipping_cost_name", { defaultValue: "ຄ່າຂົນສົ່ງ" }),
      cash: t("cash_money_name", { defaultValue: "ເງິນສົດ" }),
      transfer: t("transfer_money_name", { defaultValue: "ເງິນໂອນ" }),
      debt: t("in_debt", { defaultValue: "ຕິດໜີ້" }),
      grandTotal: t("bill_grand_total", { defaultValue: "ລວມທັງໝົດ" }),
      paymentMethod: t("payment_method", { defaultValue: "ປະເພດຊຳລະ" }),
      signApprover: t("bill_sign_approver", { defaultValue: "ເຊັນຜູ້ອານຸມັດ" }),
      signReceiverGoods: t("bill_sign_receiver_goods", { defaultValue: "ເຊັນຜູ້ຮັບເຄື່ອງ" }),
      signSenderGoods: t("bill_sign_sender_goods", { defaultValue: "ເຊັນຜູ້ສົ່ງເຄື່ອງ" }),
      signReceiverMoney: t("bill_sign_receiver_money", { defaultValue: "ເຊັນຜູ້ຮັບເງິນ" }),
    //   thankYou: t("thank_you", { defaultValue: "ຂໍຂອບໃຈທີ່ມາອຸດໜຸນ" }),
    }),
    [i18n.language, t]
  );

  const orderDate = moment(orderGroup?.createdAt).isValid()
    ? moment(orderGroup?.createdAt).format("DD/MM/YYYY")
    : moment().format("DD/MM/YYYY");

  const mapCurrency = (currency) => {
    switch (currency) {
      case "LAK":
      case "ກີບ":
        return "₭";
      case "BAHT":
      case "ບາດ":
        return "฿";
      case "USD":
      case "ໂດລາ":
        return "$";
      default:
        return "₭";
    }
  };

  const getLotNumber = (row) => {
    const fromSurvival =
      row?.survivalNumber ??
      row?.survival?.survivalNumber ??
      row?.survival ??
      row?.survivalId?.survivalNumber ??
      row?.stock?.survivalId?.survivalNumber ??
      row?.stock?.survival?.survivalNumber ??
      row?.stock?.survivalNumber;

    if (typeof fromSurvival === "string" && fromSurvival.trim()) return fromSurvival.trim();
    if (typeof fromSurvival === "number") return String(fromSurvival);
    if (typeof row?.survivalId === "string" && row?.survivalId) return row.survivalId;
    if (typeof row?.stock?.survivalId === "string" && row?.stock?.survivalId) return row.stock.survivalId;
    return "-";
  };

  const cell = {
    padding: "8px",
    border: "1px solid #d1d5db",
    fontSize: 12,
    verticalAlign: "middle",
  };

  const headerCell = {
    ...cell,
    fontWeight: 700,
    textAlign: "center",
    background: "#f3f4f6",
    color: "#111827",
  };

  const moneyRow = (label, value) => (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 12, marginBottom: 6 }}>
      <div style={{ color: "#111827" }}>{label}</div>
      <div style={{ fontWeight: 700, color: "#111827" }}>{value}</div>
    </div>
  );

  const paymentStatus = orderGroup?.debt > 0 ? "ຄ້າງໜີ້" : convertOrderStatus(status || orderGroup?.status);

  return (
    <>
      <style>
        {`
          @media print {
            @page { size: A4; margin: 6mm; }

            .bill-a4v3 {
              width: 210mm !important;
              min-height: 277mm !important;
              margin: 0 auto !important;
              display: flex !important;
              flex-direction: column !important;
            }

            .bill-a4v3-content {
              padding: 6mm 6mm !important;
              flex: 1 1 auto !important;
              display: flex !important;
              flex-direction: column !important;
            }

            .bill-a4v3 table th,
            .bill-a4v3 table td {
              padding: 4px 6px !important;
              font-size: 10.5px !important;
            }

            .bill-a4v3-thanks {
              margin-top: auto !important;
              padding-top: 3mm !important;
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }

            .bill-a4v3-footer {
              padding-top: 3mm !important;
              page-break-inside: avoid !important;
              break-inside: avoid !important;
              display: flex !important;
              flex-direction: column !important;
              flex: 1 1 auto !important;
            }
          }
        `}
      </style>
      <div className="bill-a4v3" style={{ width: "210mm", minHeight: "297mm", margin: "0 auto", backgroundColor: "#fff", color: "#111827", display: "flex", flexDirection: "column" }}>
        <div className="bill-a4v3-content" style={{ padding: "12px 14px", flex: "1 1 auto", display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16 }}>
          <div style={{ width: 90, minWidth: 90 }}>
            {props?.base64Image ? (
              <img src={props.base64Image} alt="shop-logo" style={{ maxWidth: 90, maxHeight: 90, objectFit: "contain" }} />
            ) : (
              <div style={{ width: 90, height: 90 }} />
            )}
          </div>
          <div style={{ flex: 1, textAlign: "center" }}>
            <div style={{ fontSize: 16, fontWeight: 800 }}>{shop?.name || ""}</div>
            <div style={{ fontSize: 11, marginTop: 2 }}>
              {[shop?.descriptionPOSBill, shop?.address?.village, shop?.address?.district, shop?.address?.province]
                .filter(Boolean)
                .join(", ")}
            </div>
            <div style={{ fontSize: 11, marginTop: 2 }}>
              {shop?.phone ? `${text.tel}: ${shop.phone}` : ""}
              {shop?.phoneSeconde ? `, ${shop.phoneSeconde}` : ""}
            </div>
            {shop?.businessNumber ? (
              <div style={{ fontSize: 11, marginTop: 2 }}>{`ເລກທະບຽນ: ${shop.businessNumber}`}</div>
            ) : null}
            <div style={{ marginTop: 10, fontSize: 16, fontWeight: 900, color: themePrimary }}>
              {text.invoiceTitle}
            </div>
            <div style={{ height: 2, width: 180, margin: "6px auto 0", background: themeGradient }} />
          </div>
          <div style={{ width: 90, minWidth: 90 }} />
        </div>

        <div style={{ display: "flex", gap: 12, marginTop: 14 }}>
          <div style={{ flex: 1, padding: 2 }}>
            <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 6, color: "#111827" }}>{text.customerInfoTitle}</div>
            <div style={{ fontSize: 12, marginBottom: 4 }}>
              <span style={{ fontWeight: 700 }}>{text.customerName}: </span>
              {`${props?.customername || ""} ${props?.customerLastName || ""}`.trim() || "-"}
            </div>
            <div style={{ fontSize: 12, marginBottom: 4 }}>
              <span style={{ fontWeight: 700 }}>{text.address}: </span>
              {[
                props?.village ? `ບ້ານ ${props.village}` : null,
                props?.district ? `ເມືອງ ${props.district}` : null,
                props?.province ? `ແຂວງ ${props.province}` : null,
              ].filter(Boolean).join(", ") || "-"}
            </div>
            <div style={{ fontSize: 12, marginBottom: 4 }}>
              <span style={{ fontWeight: 700 }}>{text.phoneNumber}: </span>
              {props?.phonenumber || "-"}
            </div>
            <div style={{ fontSize: 12 }}>
              <span style={{ fontWeight: 700 }}>{text.createdBy}: </span>
              {`${userData?.firstName || ""} ${userData?.lastName || userData?.nickname || ""}`.trim() || "-"}
            </div>
          </div>
          <div style={{ width: 320, padding: 2 }}>
            <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 6, color: "#111827" }}>{text.billInfoTitle}</div>
            <div style={{ fontSize: 12, marginBottom: 4 }}>
              <span style={{ fontWeight: 700 }}>{text.billNo}: </span>
              {props?.gencodeordergroup || "-"}
            </div>
            <div style={{ fontSize: 12, marginBottom: 4 }}>
              <span style={{ fontWeight: 700 }}>{text.dayMonthYear}: </span>
              {orderDate}
            </div>

            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              <div style={{ fontSize: 12, fontWeight: 700 }}>{text.currency}:</div>
              {[
                { key: "LAK", label: "KIP" },
                { key: "BAHT", label: "THB" },
                { key: "USD", label: "USD" },
              ].map((c) => (
                <label key={c.key} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12 }}>
                  <input type="checkbox" readOnly checked={(props?.selectedPayCurrency || orderGroup?.currency || "LAK") === c.key} />
                  {c.label}
                </label>
              ))}
            </div>
          </div>
        </div>

        <div style={{ marginTop: 12 }}>
          <Table responsive bordered size="sm" style={{ marginBottom: 0, borderColor: "#d1d5db" }}>
            <thead>
              <tr>
                <th style={{ ...headerCell, width: 40 }}>{text.tbNo}</th>
                <th style={{ ...headerCell, width: 110 }}>{text.tbLot}</th>
                <th style={headerCell}>{text.productName}</th>
                <th style={{ ...headerCell, width: 90 }}>{text.tbSize}</th>
                <th style={{ ...headerCell, width: 70 }}>{text.qty}</th>
                {showFreeColumn ? <th style={{ ...headerCell, width: 70 }}>{text.tbFree}</th> : null}
                <th style={{ ...headerCell, width: 90 }}>{text.unit}</th>
                <th style={{ ...headerCell, width: 110 }}>{text.price}</th>
                <th style={{ ...headerCell, width: 120 }}>{text.tbAmount}</th>
              </tr>
            </thead>
            <tbody>
              {orders?.length > 0 ? (
                orders?.map((e, index) => (
                  <React.Fragment key={`row-${index}`}>
                    <tr>
                      <td style={{ ...cell, textAlign: "center" }}>{index + 1}</td>
                      <td style={{ ...cell, textAlign: "center" }}>{getLotNumber(e)}</td>
                      <td style={cell}>{e?.productName || ""}</td>
                      <td style={{ ...cell, textAlign: "center" }}>{e?.size ?? e?.stock?.size ?? "-"}</td>
                      <td style={{ ...cell, textAlign: "center" }}>{e?.amount ?? "-"}</td>
                      {showFreeColumn ? <td style={{ ...cell, textAlign: "center" }}>{e?.amountFree > 0 ? e.amountFree : ""}</td> : null}
                      <td style={{ ...cell, textAlign: "center" }}>{e?.unit || "-"}</td>
                      <td style={{ ...cell, textAlign: "right" }}>
                        {(() => {
                          const basePrice = Number(e?.price || 0);
                          const optionPrice = (e?.options || []).reduce((acc, item) => acc + Number(item?.price || 0), 0);
                          return `${numberFormat(basePrice + optionPrice)}${mapCurrency(e?.currency)}`;
                        })()}
                      </td>
                      <td style={{ ...cell, textAlign: "right" }}>
                        {numberFormat(e?.totalPrice || 0)}
                        {mapCurrency(e?.currency)}
                      </td>
                    </tr>
                    {Array.isArray(e?.children) && e.children.length > 0
                      ? e.children.map((child, childIndex) => (
                          <tr key={`child-${index}-${childIndex}`}>
                            <td style={{ ...cell, textAlign: "center" }}>{`${index + 1}.${childIndex + 1}`}</td>
                            <td style={{ ...cell, textAlign: "center" }}>{getLotNumber(child)}</td>
                            <td style={cell}>{child?.productName || ""}</td>
                            <td style={{ ...cell, textAlign: "center" }}>{child?.size ?? child?.stock?.size ?? "-"}</td>
                            <td style={{ ...cell, textAlign: "center" }}>{child?.amount ?? child?.volume ?? "-"}</td>
                            {showFreeColumn ? <td style={{ ...cell, textAlign: "center" }}>{child?.amountFree > 0 ? child.amountFree : ""}</td> : null}
                            <td style={{ ...cell, textAlign: "center" }}>{child?.unit || "-"}</td>
                            <td style={{ ...cell, textAlign: "right" }}>{numberFormat(child?.price || 0)}{mapCurrency(child?.currency)}</td>
                            <td style={{ ...cell, textAlign: "right" }}>{numberFormat(child?.totalPrice || 0)}{mapCurrency(child?.currency)}</td>
                          </tr>
                        ))
                      : null}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td style={{ ...cell, textAlign: "center" }} colSpan={showFreeColumn ? 9 : 8}>
                    {text.noData}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <div style={{ display: "flex", gap: 12, marginTop: 10 }}>
          <div style={{ flex: 1, padding: 2, minHeight: 86 }}>
            <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6 }}>{text.note}</div>
            <div style={{ fontSize: 11, color: "#374151" }}>{shop?.note || text.noteDefault}</div>
          </div>
          <div style={{ width: 360, padding: 2 }}>
            {orderGroup?.discount > 0
              ? moneyRow(
                  text.discount,
                  `${numberFormat(orderGroup.discount || 0)} ${orderGroup?.discountType ? "₭" : "%"}`
                )
              : null}
            {Number(orderGroup?.shippingCost || 0) > 0
              ? moneyRow(text.shippingCost, `${numberFormat(orderGroup.shippingCost || 0)} ₭`)
              : null}
            {Number(orderGroup?.cash || 0) > 0 ? moneyRow(text.cash, `${numberFormat(orderGroup.cash || 0)} ₭`) : null}
            {Number(orderGroup?.transfer || 0) > 0 ? moneyRow(text.transfer, `${numberFormat(orderGroup.transfer || 0)} ₭`) : null}
            {Number(orderGroup?.debt || 0) > 0 ? moneyRow(text.debt, `${numberFormat(orderGroup.debt || 0)} ₭`) : null}
            <div style={{ height: 1, background: "#d1d5db", margin: "8px 0" }} />
            {orderGroup?.sumPriceBaht > 0 ? moneyRow("", `${numberFormat(orderGroup.sumPriceBaht || 0)} ฿`) : null}
            {orderGroup?.sumPriceUsd > 0 ? moneyRow("", `${numberFormat(orderGroup.sumPriceUsd || 0)} $`) : null}
            {moneyRow(text.grandTotal, `${numberFormat(orderGroup?.sumPrice || 0)} ₭`)}
          </div>
        </div>

        <div className="bill-a4v3-footer" style={{ paddingTop: 10, display: "flex", flexDirection: "column", flex: "1 1 auto" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 12, alignItems: "stretch" }}>
            <div style={{ padding: 2 }}>
              <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 8, color: "#111827" }}>{text.paymentMethod}</div>
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap", fontSize: 12 }}>
                <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <input
                    type="checkbox"
                    readOnly
                    checked={
                      Number(orderGroup?.cash || 0) > 0 ||
                      (!orderGroup?.transfer && !orderGroup?.debt && props?.activeTab === "CASH")
                    }
                  />
                  {text.cash}
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <input type="checkbox" readOnly checked={Number(orderGroup?.transfer || 0) > 0 || props?.activeTab === "TRANSFER"} />
                  {text.transfer}
                </label>
                <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <input type="checkbox" readOnly checked={Number(orderGroup?.debt || 0) > 0 || props?.activeTab === "DEBT"} />
                  {text.debt}
                </label>
              </div>
            </div>

            <div style={{ padding: 2 }}>
              <div style={{ display: "flex", gap: 12, flexWrap: "nowrap" }}>
                <div style={{ flex: 1, textAlign: "center" }}>
                  <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 46, color: "#111827" }}>{text.signApprover}</div>
                  <div style={{ borderTop: "1px solid #111827", width: "90%", margin: "0 auto" }} />
                </div>
                <div style={{ flex: 1, textAlign: "center" }}>
                  <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 46, color: "#111827" }}>{text.signReceiverGoods}</div>
                  <div style={{ borderTop: "1px solid #111827", width: "90%", margin: "0 auto" }} />
                </div>
                <div style={{ flex: 1, textAlign: "center" }}>
                  <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 46, color: "#111827" }}>{text.signSenderGoods}</div>
                  <div style={{ borderTop: "1px solid #111827", width: "90%", margin: "0 auto" }} />
                </div>
                <div style={{ flex: 1, textAlign: "center" }}>
                  <div style={{ fontSize: 12, fontWeight: 800, marginBottom: 46, color: "#111827" }}>{text.signReceiverMoney}</div>
                  <div style={{ borderTop: "1px solid #111827", width: "90%", margin: "0 auto" }} />
                </div>
              </div>
            </div>
          </div>

          <div className="bill-a4v3-thanks" style={{ textAlign: "center", marginTop: "auto", paddingTop: 8, fontSize: 11, color: "#374151" }}>
            {text.thankYou}
          </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default BillForCheckOutA4V3;
